module.exports = __webpack_public_path__ + "static/odeghe-2335b0a47045d3bad8afe39fa7f9cc78.png";